<template>
  <div class="label-row">
    <label :for="props.for" :class="props.labelClass ?? 'label-class'"  v-html="props.label">
    </label>

    <span v-if="props.toolTipLabel" :class="tooltipClass ?? 'label-tooltip'">
      <Tooltip :message="props.toolTipLabel" type="info" />
    </span>
  </div>
</template>

<script setup lang="ts">
import Tooltip from "@/components/Tooltip.vue";

const props = defineProps<{
  label: string;
  for?: string;
  labelClass?: string;
  toolTipLabel?: string;
  tooltipClass?: string;
}>();
</script>

<style scoped lang="scss">
@import "@env_styles/variables";

.label-row {
  margin-bottom: 0.25rem;
  display: flex;
 

  .label-class {
  color: $text-color;
}
  

  .label-tooltip {
    margin-left: 0.3rem;
  }
}
</style>